import { HeadlineSize } from '@postidigital/posti-components'
import { observer } from 'mobx-react-lite'
import React, { PropsWithChildren } from 'react'

import { AppModal, AppModalProps } from '../../../components'

const capitalizeFirstLetter = (p: string) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()

type RegistrationModalProps = Omit<AppModalProps, 'title' | 'titleSize'> & {
  title: string
}

export const RegistrationModal: React.FC<PropsWithChildren<RegistrationModalProps>> = observer(
  ({ children, isOpen, title, onClose, showCloseButton = true, controls, ...modalProps }) => {
    return (
      <AppModal
        isOpen={isOpen}
        title={capitalizeFirstLetter(title)}
        titleSize={HeadlineSize.Five}
        onClose={onClose}
        showCloseButton={showCloseButton}
        controls={controls}
        {...modalProps}
      >
        {children}
      </AppModal>
    )
  }
)
